import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// استيراد ملفات الترجمة
import translationAR from './locales/ar.json';
import translationEN from './locales/en.json';

// تجميع ملفات الترجمة
const resources = {
  ar: {
    translation: translationAR
  },
  en: {
    translation: translationEN
  }
};

// إعداد i18n
i18n
  .use(LanguageDetector) // لاكتشاف لغة المتصفح تلقائياً
  .use(initReactI18next) // ربط i18n مع React
  .init({
    resources, // ملفات الترجمة
    fallbackLng: 'ar', // اللغة الافتراضية
    debug: false, // تعطيل رسائل التصحيح في الإنتاج
    
    interpolation: {
      escapeValue: false // React يتعامل مع XSS تلقائياً
    },
    
    // إعدادات اكتشاف اللغة
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'], // ترتيب البحث عن اللغة
      caches: ['localStorage'] // حفظ اللغة المختارة في localStorage
    }
  });

export default i18n;